import { RootAction } from "../types";
import { GET_CONVERSATIONS_SUCCESS } from "./actions";
import { ConversationState } from "./types";

const initialConversationState: ConversationState = {
  conversations: [],
};

export function conversationReducer(
  state: ConversationState = initialConversationState,
  action: RootAction
): ConversationState {
  switch (action.type) {
    case GET_CONVERSATIONS_SUCCESS:
      return {
        conversations: action.conversations,
      };

    default:
      return state;
  }
}
